import { render } from "./Card.vue?vue&type=template&id=ec94aee0"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=ec94aee0&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__